import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TestNavPage = () => {

  return (
    <Container fluid>
        <Col style={{paddingTop: 100}}>
          <Row style={{ display: 'flex', justifyContent: 'center'}}>
            Test Navigation
        </Row>
          <Row style={{ display: 'flex', justifyContent: 'center'}}>
            <Link aria-label="PLACEHOLDER" to="/">
              Navigate back to home page
          </Link>
          </Row>

        </Col>
    </Container>
  )
}

export default TestNavPage;